/** Bootstrap grid kolon düzeni: sıra, genişlik, görünürlük. */

export function columnLayoutId(col, index = 0) {
  const field = String(col?.dataField || col?.caption || '').trim();
  return field || `col-${index}`;
}

export function columnPixelWidth(column) {
  const n = Number(column?.width);
  return Number.isFinite(n) && n >= 48 ? Math.round(n) : null;
}

export function hashText(text) {
  let h = 0;
  const value = String(text || '');
  for (let i = 0; i < value.length; i += 1) {
    h = (Math.imul(31, h) + value.charCodeAt(i)) | 0;
  }
  return (h >>> 0).toString(36);
}

export function resolveLayoutKey(layoutKey, columns) {
  const explicit = String(layoutKey || '').trim();
  if (explicit) return explicit.slice(0, 80);
  const path = typeof window !== 'undefined' ? window.location.pathname : 'grid';
  const fields = (columns || []).map((col, index) => columnLayoutId(col, index)).join('|');
  return `auto:${hashText(`${path}:${fields}`)}`;
}

export function applyColumnLayout(sourceColumns, layout) {
  const source = (sourceColumns || []).map((col, index) => ({
    ...col,
    _layoutId: columnLayoutId(col, index),
  }));
  const saved = layout?.columns;
  if (!Array.isArray(saved) || saved.length === 0) return source;
  const byId = new Map(source.map((col) => [col._layoutId, col]));
  const used = new Set();
  const ordered = [];
  saved.forEach((item) => {
    const id = String(item?.dataField || '');
    const col = byId.get(id);
    if (!col || used.has(id)) return;
    used.add(id);
    const width = columnPixelWidth(item);
    ordered.push({
      ...col,
      visible: item.visible !== false,
      width: width || col.width,
    });
  });
  source.forEach((col) => {
    if (!used.has(col._layoutId)) ordered.push(col);
  });
  return ordered;
}

export function moveColumn(list, fromId, toId) {
  const from = list.findIndex((col) => col._layoutId === fromId);
  const to = list.findIndex((col) => col._layoutId === toId);
  if (from < 0 || to < 0 || from === to) return list;
  const next = list.slice();
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}

export function moveColumnBy(list, id, delta) {
  const from = list.findIndex((col) => col._layoutId === id);
  if (from < 0) return list;
  const to = from + delta;
  if (to < 0 || to >= list.length) return list;
  const next = list.slice();
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}

export function snapshotColumns(columns) {
  return {
    columns: (columns || []).map((col) => ({
      dataField: col._layoutId,
      visible: col.visible !== false,
      width: columnPixelWidth(col),
    })),
  };
}

export function beginColumnResize(event, column, onResize) {
  event.preventDefault();
  event.stopPropagation();
  const th = event.currentTarget?.closest?.('th');
  const startX = event.clientX;
  const startW = th?.offsetWidth || columnPixelWidth(column) || 120;
  const id = column._layoutId;
  const move = (ev) => {
    const next = Math.max(48, Math.min(800, Math.round(startW + ev.clientX - startX)));
    onResize(id, next);
  };
  const up = () => {
    window.removeEventListener('mousemove', move);
    window.removeEventListener('mouseup', up);
  };
  window.addEventListener('mousemove', move);
  window.addEventListener('mouseup', up);
}
